


























































































import { Component, Watch, Vue } from 'vue-property-decorator'
/* module */
import { plantingSeason } from '@/app/model/store/domain/const'
import Local from '@/app/module/local'

@Component
export default class ProfitHeader extends Vue {
  private yearList: number[] = []
  private year: string = ''
  private season: string = ''
  private isActive: string = '1'
  private seasonList: string[] = []

  created () {
    this.year = String(new Date().getFullYear())
    this.season = String(plantingSeason.MAIN)

    /* 選択する年の配列を作成 */
    let endYear = new Date().getFullYear() + 1
    const constantValue = JSON.parse(Local.getConstantValue()!)
    let minPlantYear = constantValue.min_plant_year
    if (minPlantYear === null) {
      minPlantYear = new Date().getFullYear()
    }
    for (let i = minPlantYear; i <= endYear; i++) {
      this.yearList.unshift(i)
    }
    this.seasonList = constantValue.seasons
  }

  private changeTab (val: string) {
    this.isActive = val
    this.$emit('change-tab', val)
  }

  private changeYearData () {
    this.$store.commit('profitState/setSelectedYear', this.year)
  }

  private changeSeasonData () {
    this.$store.commit('profitState/setSelectedSeason', this.season)
  }
}
